// extracted by mini-css-extract-plugin
export default {"success":"index_success_JHZAb","successBox":"index_successBox_D4Rog","successCallback":"index_successCallback_bVX1I"};